import { NgModule, OnInit } from '@angular/core';
import { Router, RouterModule, Routes, Route } from '@angular/router';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { PortalService } from '../../../../../services/portal.service';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { PatientInfoComponent } from './patient-info/patient-info.component';
import { IncomeInfoComponent } from './income-info/income-info.component';
import { InsuranceInfoComponent } from './insurance-info/insurance-info.component';
import { PhysicianInfoComponent } from './physician-info/physician-info.component';
import { ReviewInfoComponent } from './review-info/review-info.component';
import { SignaturesComponent } from './signatures/signatures.component';
import { environment } from '../../../../../environments/environment';

interface EnrollmentStep {
  enrollmentRoute: string;
  sequenceNumber: string;
  enrollmentStepName: string;
}

@NgModule({
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
})
export class EnrollmentRoutingModule implements OnInit {
  private componentMap: { [key: string]: any } = {
    Profile: PatientInfoComponent,
    Income: IncomeInfoComponent,
    Insurance: InsuranceInfoComponent,
    Physician: PhysicianInfoComponent,
    Review: ReviewInfoComponent,
    Signatures: SignaturesComponent,
  };

  private cachedSteps$: Observable<EnrollmentStep[]>; // Explicit type for observable

  constructor(private router: Router, private portalService: PortalService) {}

  ngOnInit(): void {
    this.cachedSteps$ = this.portalService.getEnrollmentSteps(environment.programID).pipe(
      map((steps: EnrollmentStep[]) =>
        steps
          .filter((step: EnrollmentStep) => step.enrollmentRoute !== 'N/A' && step.sequenceNumber !== 'N/A')
          .sort((a: EnrollmentStep, b: EnrollmentStep) => +a.sequenceNumber - +b.sequenceNumber)
      ),
      shareReplay(1) // Cache response
    );

    this.configureDynamicRoutes();
  }

  private configureDynamicRoutes(): void {
    this.cachedSteps$.subscribe((sortedSteps: EnrollmentStep[]) => {
      const dynamicChildRoutes: Route[] = [
        { path: '', redirectTo: 'Profile', pathMatch: 'full' },
        ...sortedSteps.map((step: EnrollmentStep) => ({
          path: step.enrollmentRoute.replace('/', ''),
          component: this.componentMap[step.enrollmentStepName] || PatientInfoComponent,
        })),
      ];

      const currentConfig = this.router.config;

      const parentRoute = currentConfig.find(route => route.path === 'enrollment');

      if (parentRoute) {
        if (!parentRoute.children) {
          parentRoute.children = [];
        }

        // Avoid duplicating routes
        const newRoutes = dynamicChildRoutes.filter(
          (route) => !parentRoute.children?.find((child) => child.path === route.path)
        );

        if (newRoutes.length > 0) {
          parentRoute.children.push(...newRoutes);
          this.router.resetConfig(currentConfig);
          console.log('Router configuration updated with dynamic routes:', this.router.config);
        } else {
          console.log('No new routes to add. Configuration unchanged.');
        }
      } else {
        console.warn('Parent route not found for "enrollment".');
      }
    });
  }
}
